module.exports = __webpack_public_path__ + "static/media/logoA.ab18ad2f.png";